import ProgressionTemplateResourceInstance from "../../../../resources/expapiunified/ProgressionTemplate.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const {
  epic: progressionTemplatesEpic,
  reducer: progressionTemplatesReducer,
  actions: progressionTemplatesActions,
  selectors,
  getDefaultReducerState: getDefaultProgressionTemplatesReducerState
} = createUnifiedRestApi(
  ProgressionTemplateResourceInstance,
  "progression-templates",
  (state) => state.progressionTemplates
).create();
const {
  selectAll: selectAllProgressionTemplates,
  selectById: selectProgressionTemplateById,
  selectQueryAsyncRequest: selectQueryProgressionTemplatesAsyncRequest,
  selectGetAsyncRequest: selectGetProgressionTemplateAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateProgressionTemplateAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteProgressionTemplateAsyncRequest
} = selectors;
const {
  getAsync: getProgressionTemplateAsync,
  queryAsync: queryProgressionTemplatesAsync,
  createOrUpdateAsync: createOrUpdateProgressionTemplateAsync,
  deleteAsync: deleteProgressionTemplateAsync
} = progressionTemplatesActions;
export {
  createOrUpdateProgressionTemplateAsync,
  deleteProgressionTemplateAsync,
  getDefaultProgressionTemplatesReducerState,
  getProgressionTemplateAsync,
  progressionTemplatesEpic,
  progressionTemplatesReducer,
  queryProgressionTemplatesAsync,
  selectAllProgressionTemplates,
  selectCreateOrUpdateProgressionTemplateAsyncRequest,
  selectDeleteProgressionTemplateAsyncRequest,
  selectGetProgressionTemplateAsyncRequest,
  selectProgressionTemplateById,
  selectQueryProgressionTemplatesAsyncRequest
};
//# sourceMappingURL=progression-templates.js.map
